import appConfig from "../app.config";

var oauthSettings = {
  client_id: appConfig.settings.clientId,
  scope: appConfig.settings.scope,
  authorize_url: appConfig.settings.authorizeUrl,
  token_url: appConfig.settings.tokenUrl,
  logout_url: appConfig.settings.logoutUrl,
  redirect_uri: window.location.origin, //Gets the current
  autologin: true,
  debug: false,
};

/*----------------------------- Be careful below this line -------------------------------*/

import oauthWrapper from "@/_components/security/oauth/oauth-wrapper.vue";
import credentialsMixin from "@/_mixins/credentials-mixin";

export default {
  components: { oauthWrapper },
  mixins: [credentialsMixin],
  data() {
    return Object.assign({ loginIncrementor: 0 }, oauthSettings);
  },
  computed: {
    credentials: {
      get() {
        if (this.credentialCacheUID > 0) {
          return this.getCredentials(this.client_id);
        }
        return null;
      },
      set(newVal) {
        if (!!newVal) {
          this.addCredentials(this.client_id, newVal);
        }
      },
    },
    isLoggedIn() {
      return !!this.credentials;
    }
  },
  methods: {
    login() {
      this.deleteCredentials(this.client_id);
      this.credentials = null;
      this.$nextTick((e) => {
        this.loginIncrementor++;
      }); //forces the login event on the child component
    },
  },
};
